export default {
  FETCH_SITE_FINANCIAL_STATUS_REQUEST: 'FETCH_SITE_FINANCIAL_STATUS_REQUEST',
  FETCH_SITE_FINANCIAL_STATUS_SUCCESS: 'FETCH_SITE_FINANCIAL_STATUS_SUCCESS',
  FETCH_SITE_FINANCIAL_STATUS_FAILURE: 'FETCH_SITE_FINANCIAL_STATUS_FAILURE',
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/actions/site-financial-status/action-types.js